import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-xl font-bold text-[#7dd3fc] mb-3">{title}</h2>
    <div className="text-white/70 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#0a1628] py-16 px-6" data-testid="privacy-page">
      <div className="container mx-auto max-w-3xl">
        <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-[#7dd3fc] transition-colors mb-8" data-testid="privacy-back-link">
          <ArrowLeft size={18} />
          <span>Voltar ao site</span>
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Política de <span className="text-[#7dd3fc]">Privacidade</span>
          </h1>
          <p className="text-white/40 mb-12">Última atualização: Janeiro de 2025</p>

          <Section title="1. Informações que Coletamos">
            <p>
              Coletamos informações que você nos fornece diretamente, como nome, e-mail, telefone e mensagens
              enviadas através do nosso formulário de contato. Também podemos coletar dados de navegação através de cookies.
            </p>
          </Section>

          <Section title="2. Como Usamos suas Informações">
            <p>
              Utilizamos suas informações para responder solicitações de orçamento, melhorar nossos serviços,
              enviar comunicações comerciais (quando autorizado) e cumprir obrigações legais.
            </p>
          </Section>

          <Section title="3. Cookies">
            <p>
              Nosso site utiliza cookies para melhorar sua experiência de navegação. Você pode gerenciar suas
              preferências de cookies através do banner de consentimento exibido ao acessar o site.
            </p>
          </Section>

          <Section title="4. Compartilhamento de Dados">
            <p>
              Não vendemos nem compartilhamos suas informações pessoais com terceiros, exceto quando necessário
              para prestação de serviços ou por exigência legal.
            </p>
          </Section>

          <Section title="5. Seus Direitos (LGPD)">
            <p>
              De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem o direito de acessar, corrigir,
              excluir e solicitar a portabilidade dos seus dados pessoais. Para exercer esses direitos, entre em contato conosco.
            </p>
          </Section>

          <Section title="6. Segurança">
            <p>
              Adotamos medidas de segurança técnicas e organizacionais para proteger suas informações pessoais
              contra acesso não autorizado, perda ou uso indevido.
            </p>
          </Section>

          <Section title="7. Contato">
            <p>
              Para questões sobre privacidade e proteção de dados, entre em contato através do e-mail{' '}
              <a href="mailto:comercial@imperioice.com.br" className="text-[#7dd3fc] hover:underline">
                comercial@imperioice.com.br
              </a>.
            </p>
          </Section>
        </motion.div>
      </div>
    </div>
  );
}
